import Nope from 'nope-validator';

export const PremiseSchema = Nope.object().shape({
  propertyName: Nope.string().required(),
  addressStreet: Nope.string().required(),
  addressTown: Nope.string().required(),
  // addressState: Nope.string().required(),
});
